import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { toJS, observable, action } from 'mobx'
import { observer } from 'mobx-react'
import classNames from 'classnames'

import Logo from '../../base/components/Logo'

import FilterNav from './FilterNav'
import SchoolsSection from './SchoolsSection'
import SubjectsSection from './SubjectsSection'
import RegionsSection from './RegionsSection'

@observer
export default class Filter extends Component {
  /* eslint-disable react/sort-comp */
  @observable section = 'schools';
  /* eslint-enable react/sort-comp */

  static propTypes = {
    filter: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    onFilterChanged: PropTypes.func.isRequired,
    onFilterClosed: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired
  };

  constructor(props) {
    super(props)
    this.section = props.filter.selected
  }

  componentWillReceiveProps(props) {
    this.section = props.filter.selected
  }

  @autobind
  @action
  handleSectionChange({ currentTarget: { value } }) {
    this.section = value
    const filter = toJS(this.props.filter)
    filter.selected = value
    this.props.onFilterChanged({
      target: {
        value: filter
      }
    })
  }

  @autobind
  handleFilterChange(e) {

    const provider = e.target
    const {
      name, value, checked, type
    } = provider

    const filter = toJS(this.props.filter)

    if (type === 'checkbox') {
      value.split(',')
        .forEach((val) => {
          const intVal = val.trim() * 1
          if (checked && filter[name].indexOf(intVal) === -1) {
            // only add the value if we don't know it yet
            filter[name] = [...filter[name], intVal].sort()
          }
          else {
            const index = filter[name].indexOf(intVal)
            filter[name] = [
              ...filter[name].slice(0, index),
              ...filter[name].slice(index + 1)
            ]
          }
        })
    }
    else if (name.indexOf('[') !== -1) {
      const [fieldName, fieldIndex] = name
        .match(/([^[]+)\[([^\]]+)\]/)
        .slice(1)
      filter[fieldName][fieldIndex * 1] = value
    }
    else {
      filter[name] = value
    }

    this.props.onFilterChanged({
      target: {
        value: filter
      }
    })
  }

  @autobind
  handleSchoolsFilterRemove() {
    this.removeFilter('school')
  }

  @autobind
  handleSubjectsFilterRemove() {
    this.removeFilter('subject')
  }

  @autobind
  handleRegionsFilterRemove() {
    this.removeFilter('region')
  }

  @autobind
  handleCloseFilters() {
    this.props.onFilterClosed()
  }

  removeFilter(type) {
    const filter = toJS(this.props.filter)

    filter[type] = []

    this.props.onFilterChanged({
      target: {
        value: filter
      }
    })
  }

  ensureArray(expectedArray) {
    expectedArray = toJS(expectedArray)
    if (!Array.isArray(expectedArray)) {
      return [expectedArray]
    }
    return expectedArray
  }

  render() {
    return (
      <div
        id="app-sidebar"
        className={classNames('app-sidebar', {
          open: this.props.open
        })}
      >
        <Logo />

        <FilterNav
          onOpenSection={this.handleSectionChange}
          section={this.section}
        />

        <div className="filter-container">
          <div className="filter" onChange={this.handleFilterChange}>
            <SchoolsSection
              section={this.section}
              schools={this.ensureArray(this.props.filter.school)}
              grade={this.props.filter.grade}
              groupSize={this.props.filter.groupSize}
              onChange={this.handleFilterChange}
              onRemove={this.handleSchoolsFilterRemove}
            />

            <SubjectsSection
              section={this.section}
              subjects={this.ensureArray(this.props.filter.subject)}
              onRemove={this.handleSubjectsFilterRemove}
            />

            <RegionsSection
              section={this.section}
              regions={this.ensureArray(this.props.filter.region)}
              onRemove={this.handleRegionsFilterRemove}
            />
          </div>
        </div>

        <footer className="visible-xs">
          <button
            className="btn btn-primary apply-filters"
            onClick={this.handleCloseFilters}
          >
            Filter anwenden und schließen
          </button>
        </footer>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/frontend/map/components/Filter.js